export default __webpack_public_path__ + "static/media/rmbackground-before.bf785cef.png";